import {
  InputCheckbox,
  InputSelect,
  InputText,
  FormField,
  FormRow,
  Toaster,
} from "@endya-conformite/ui-kit";
import { GatewayAdresse, GatewayInfoSocieteOrias } from "@conformite/gateway";
import {
  paysOptions,
  typeVoieOptions,
} from "@src/societes/form/EntrepriseAdresseForm";
import { ID_FORM_SOCIETE_INFORMATION } from "../SocieteInformation";
import { SocieteInformationActions } from "../SocieteInformationActions";
import { SocieteInformationFormBloc } from "./SocieteInformationFormBloc";
import { SocieteInformationFormValues } from "../useSocieteInformation";
import styles from "../SocieteInformation.module.scss";

type AdresseInformationProps = {
  categories: GatewayInfoSocieteOrias.Categorie[];
  formState: {
    isDirty: boolean;
  };
  isLoading: boolean;
  onCancel: () => void;
};

export function AdresseInformation({
  categories,
  formState,
  isLoading,
  onCancel,
}: AdresseInformationProps) {
  return (
    <SocieteInformationFormBloc title="Adresse">
      <FormRow>
        <FormField>
          <InputSelect<SocieteInformationFormValues, GatewayAdresse.TypeVoie>
            isSearchable
            name="typeVoie"
            label="Type de voie"
            placeholder="Sélectionner"
            options={typeVoieOptions}
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Libellé de la voie"
            name="libelleVoie"
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Numéro de rue"
            name="numeroVoie"
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Complément d'adresse"
            name="complementAdresse"
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputSelect<SocieteInformationFormValues, GatewayAdresse.Pays>
            name="pays"
            label="Pays"
            placeholder="Sélectionner"
            options={paysOptions}
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField size="quarter">
          <InputText<SocieteInformationFormValues>
            label="Code postal"
            name="codePostal"
            required
          />
        </FormField>
        <FormField size="three-quarter">
          <InputText<SocieteInformationFormValues>
            label="Ville"
            name="ville"
            required
          />
        </FormField>
      </FormRow>
      {categories.includes(GatewayInfoSocieteOrias.Categorie.COA) && (
        <FormRow>
          <FormField>
            <InputCheckbox<SocieteInformationFormValues>
              name="consentementEDI"
              label="Je souhaite partager mes informations avec la plateforme EDI Conformité"
            />
          </FormField>
        </FormRow>
      )}
      {formState.isDirty && (
        <SocieteInformationActions onCancel={onCancel} isLoading={isLoading} />
      )}
      <Toaster
        canal={ID_FORM_SOCIETE_INFORMATION}
        position={{
          vertical: "bottom",
          horizontal: "center",
        }}
        className={styles.toaster}
      />
    </SocieteInformationFormBloc>
  );
}
